import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_filter_buttons = _resolveComponent("filter-buttons")
  const _component_filter_drawer = _resolveComponent("filter-drawer")

  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" Filter Controls "),
    _createVNode(_component_filter_buttons, {
      "selected-filters-count": $options.visibleSelectedFilters.length,
      "total-item-count": $props.filters.totalItemCount.value,
      "sort-display-name": $props.filters.sortDisplayName.value,
      "filters-with-display-names": $options.filtersWithDisplayNames,
      onFiltersOpen: $options.onFiltersOpen,
      onSortOpen: $options.onSortOpen,
      onFilterDelete: $options.onFilterDelete
    }, null, 8 /* PROPS */, ["selected-filters-count", "total-item-count", "sort-display-name", "filters-with-display-names", "onFiltersOpen", "onSortOpen", "onFilterDelete"]),
    _createCommentVNode(" Header Slot - View controls what goes here "),
    _renderSlot(_ctx.$slots, "header", {
      filters: $props.filters,
      onFilterChange: $options.onFilterChange
    }),
    _createCommentVNode(" Filter Drawer "),
    _createVNode(_component_filter_drawer, {
      schema: $options.filterSchema,
      "selected-filters": $options.selectedFilters,
      "is-drawer-open": $data.isFilterDrawerOpen,
      title: $props.filterListTitle,
      "has-clear-button": "",
      onSearch: $options.onApplyFilters,
      onClear: $options.onClearFilters,
      onClose: $options.onFiltersClose
    }, null, 8 /* PROPS */, ["schema", "selected-filters", "is-drawer-open", "title", "onSearch", "onClear", "onClose"]),
    _createCommentVNode(" Sort Drawer "),
    _createVNode(_component_filter_drawer, {
      schema: $options.sortSchema,
      "selected-filters": $options.selectedFilters,
      "is-drawer-open": $data.isSortDrawerOpen,
      title: $props.sortListTitle,
      onSearch: $options.onApplySort,
      onClose: $options.onSortClose
    }, null, 8 /* PROPS */, ["schema", "selected-filters", "is-drawer-open", "title", "onSearch", "onClose"]),
    _createCommentVNode(" Content Slot "),
    _renderSlot(_ctx.$slots, "default", {
      items: $props.filters.pagedItems.value,
      isProcessing: $props.filters.isProcessing.value,
      isLoadingMore: $props.filters.isLoadingMore.value,
      canLoadMore: $props.filters.canLoadMoreRows.value,
      loadMore: $props.filters.loadMoreRows
    })
  ]))
}